<template>
  <div class="cgs-home">
    <!-- <van-nav-bar title="home页面"></van-nav-bar> -->
    <div>
      <Avatar :username="name" :initials="avatarName" color="#fff" :customStyle="{ display: 'inline-flex' }"></Avatar>
      <span style="margin-left: 15px; font-weight: 600">{{ name }}</span>
    </div>

    <!-- <p style="text-align: center">{{`你好: ${name}`}}</p> -->
    <div style="margin: 30px 0px">
      <van-cell title="组织">
        <template #icon>
          <div class="cgs-home-cellIcon background1">
            <span class="iconfont cgsIcon-zuzhijigou"></span>
          </div>
        </template>
      </van-cell>
      <van-cell title="安全设置">
        <template #icon>
          <div class="cgs-home-cellIcon background2">
            <span class="iconfont cgsIcon-anquanbaozhang"></span>
          </div>
        </template>
      </van-cell>
      <van-cell title="隐私设置">
        <template #icon>
          <div class="cgs-home-cellIcon background3">
            <span class="iconfont cgsIcon-a-suosimiyinsi"></span>
          </div>
        </template>
      </van-cell>
      <van-cell title="系统设置">
        <template #icon>
          <div class="cgs-home-cellIcon background4">
            <span class="iconfont cgsIcon-shezhi"></span>
          </div>
        </template>
      </van-cell>
      <van-cell title="检查更新" @click="examine(true)">
        <template #icon>
          <div class="cgs-home-cellIcon background5">
            <span class="iconfont cgsIcon-gengxin"></span>
          </div>
        </template>
        <template #default>
          <span style="color:#ee0a24;" v-show="reminder">有新版本</span>
          <span v-show="reminder == false">{{ current }}</span>
        </template>
      </van-cell>
    </div>
    <div style="text-align: center; margin: 10px 0px">
      <van-button type="danger" style="width: 100%" @click="logout">退出登录</van-button>
    </div>
    <van-dialog v-model="showDialog" title="发现新版本" :show-confirm-button="false">
      <div style="margin-left: 30px;">
        <div>当前版本号：{{ current }}</div>
        <div>新版本号：{{ svn }}</div>
        <div>更新内容：{{ desc }}</div>
      </div>
      <div style="margin: 30px 0px 10px 0px; text-align: center">
        <van-button @click="showDialog = false" style="margin: 0px 10px">忽略此版本</van-button>
        <van-button type="primary" @click="update" style="margin: 0px 10px">立即更新</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { NavBar, Button, Cell, Dialog } from "vant";
import Avatar from "vue-avatar";
import { getUserAuthority } from "@/util/author";
import { getVersions } from "@/api/index";
import { clearAuthor } from "@/util/author";
import { getCurrentVersion, compareVersion } from "@/util/tool";
export default {
  components: {
    vanNavBar: NavBar,
    vanButton: Button,
    vanCell: Cell,
    [Dialog.Component.name]: Dialog.Component,
    Avatar,
  },
  data() {
    return {
      showDialog: false,
      name: "",
      svn: "",
      updateURL: '',
      desc: "",
      reminder: false,
      current: "",
    };
  },
  mounted() {
    let userAuthority = getUserAuthority();
    this.name = userAuthority.name;
  },
  created() {
    this.examine()
  },
  computed: {
    avatarName: {
      get() {
        return this.name.length > 2
          ? this.name.substring(this.name.length - 2)
          : this.name;
      },
      set() { },
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    logout() {
      clearAuthor();
      this.$router.push({ path: "/login" });
    },
    async examine(isPrompt = false) {
      let code = process.env.VUE_APP_CODE
      let currentVersion = getCurrentVersion();
      this.current = currentVersion
      let result = await getVersions(code);
      this.svn = result.data.version
      this.desc = result.data.desc
      let newVersion = result.data.version
      this.updateURL = result.data.link
      let info = compareVersion(currentVersion, newVersion);
      if (info == true) {
        this.reminder = true;
        if (isPrompt) this.showDialog = true;
      } else {
        this.reminder = false;
        if (isPrompt) this.$message({
          message: "当前版本" + this.current + "已为最新版本",
          center: true,
        });;
      }
    },
    // examineVersion() {
    //   if (this.reminder == true) {
    //     this.showDialog = true;
    //   } else {
    //     this.$message({
    //       message: "当前版本" + this.current + "已为最新版本",
    //       center: true,
    //     });
    //   }
    // },
    async update() {
      if (this.updateURL !== '') {
        // document.addEventListener('plusready', function () {
        this.showDialog = false;
        let downloader = plus.downloader.createDownload(this.updateURL, {}, function (d, status) {
          if (status == 200) {
            let path = d.filename;
            plus.runtime.install(path);
            this.$message({ message: '更新成功', center: true, showClose: true, });
          } else {
            //下载失败
            this.$message({ message: '更新失败', center: true, showClose: true, });
          }
        });
        downloader.start()
        // })
      }
    },
  },
};
</script>

<style scoped>
.cgs-home {
  padding: 50px 10px;
  height: unset;
}
</style>

<style>
.cgs-home .van-cell {
  padding: 10px 0px;
}

.cgs-home-cellIcon {
  width: 25px;
  height: 25px;
  /* line-height: 25px; */
  text-align: center;
  color: #fff;
  border-radius: 50%;
  margin-right: 10px;
}

.cgs-home-cellIcon.background1 {
  background: rgba(76, 175, 80, 1);
}

.cgs-home-cellIcon.background2 {
  background: rgba(33, 150, 243, 1);
}

.cgs-home-cellIcon.background3 {
  background: rgba(0, 188, 212, 1);
}

.cgs-home-cellIcon.background4 {
  background: rgba(255, 152, 0, 1);
}

.cgs-home-cellIcon.background5 {
  background: rgba(86, 124, 115, 1);
}
</style>